import React from 'react';
import { useHistory } from 'react-router-dom';
import { getOptionsMessages } from './OptionsMessages';
import ModalConfirmation from '@/presentation/modules/procedures/components/Modal/Modal';
import ContentModalTwoButtons from '@/presentation/modules/procedures/components/ContentModalTwoButtons';
import ContentModalOneButton from '@/presentation/modules/procedures/components/ContentModalOneButton';

interface IProps {
  showModal?: boolean;
  optionMessage?: any;
  handlerBack: () => void;
  itemFullCycle?: any;
}

const ModalMessageFullCycle = ({
  showModal = false,
  optionMessage,
  handlerBack,
  itemFullCycle
}: IProps) => {
  const { push } = useHistory();
  if (!optionMessage || !showModal) return null;
  const urlForSuccesActivate = getOptionsMessages().successActivate.goTo1;
  // redirection for action by option
  const handlerDefinitionGoTo = (route?: string, isBack?: boolean) => {
    if (isBack) {
      return optionMessage?.goTo1 === urlForSuccesActivate
        ? push(optionMessage.goTo1, itemFullCycle)
        : handlerBack();
    }
    if (route) {
      const destination =
        route === urlForSuccesActivate ? optionMessage?.goTo1 ?? route : route;
      return push(destination, itemFullCycle);
    }
    return handlerBack();
  };

  return (
    <div id="modal" style={{ zIndex: 1000, position: 'absolute' }}>
      <ModalConfirmation
        show={showModal}
        handleClose={() => handlerDefinitionGoTo(undefined, true)}
      >
        {optionMessage?.textBtn2 ? (
          <ContentModalTwoButtons
            align="center"
            img={optionMessage?.img}
            onClickButton1={() => handlerDefinitionGoTo(optionMessage?.goTo1)}
            onClickButton2={() => handlerDefinitionGoTo(optionMessage?.goTo2)}
            showInfo={false}
            title={optionMessage?.title}
            subtitle={optionMessage?.message}
            textButton1={optionMessage?.textBtn1}
            textButton2={optionMessage?.textBtn2}
          />
        ) : (
          <ContentModalOneButton
            img={optionMessage?.img}
            title={optionMessage?.title || ''}
            subtitle={optionMessage?.message}
            showInfo={false}
            textButton={optionMessage?.textBtn1}
            style={{ textAlign: 'center' }}
            onClickButton={() => handlerDefinitionGoTo(optionMessage?.goTo1)}
          />
        )}
      </ModalConfirmation>
    </div>
  );
};

export default ModalMessageFullCycle;
